import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import './vendor/flipdown.css'

import UiButton from './components/ui/Button.vue'
import UiFlag from './components/ui/Flag.vue'
import UiIconStack from './components/ui/IconStack.vue'
import UiModal from './components/ui/Modal.vue'
import UiParticipant from './components/ui/Participant.vue'
import UiSection from './components/ui/Section.vue'

const i18n = createI18n({
  locale: localStorage.getItem('locale') || (('' + navigator.language).slice(0, 2) === 'ru' ? 'ru' : 'en'),
  warnHtmlMessage: false,
  messages: {
    en: {},
    ru: {},
  },
})

const app = createApp(App)

app.use(i18n)

app.component('UiButton', UiButton)
app.component('UiFlag', UiFlag)
app.component('UiIconStack', UiIconStack)
app.component('UiModal', UiModal)
app.component('UiParticipant', UiParticipant)
app.component('UiSection', UiSection)

app.mount('#app')
